import React, { memo, useCallback, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectorQuiz, updateQuiz } from '../../features/quiz/quizSlice'
import Input from './Input'

const QUESTION17 = 'choice_question17'

/**
 * CHECKBOX COMPONENT
 * @param {{ valueType: 'text' | 'input', option: {name: string, value: string} | string, type: 'checkbox' | 'radio', name: string, defaultValue?: string[], idEl?: string }} props 
 * @returns {JSX.Element}
 */
function Checkbox({ valueType = 'text', option, type = 'checkbox', name = 'radio', questionNumber = null, options = [], defaultValue, idEl, ...props }) {
  const dispatch = useDispatch()
  const quiz = useSelector(selectorQuiz)
  const [isChecked, setIsChecked] = useState(defaultValue?.includes(option.value))
  const allOptions = options.filter(option => !option?.name?.startsWith('other')).map(op => op?.value)
  const [value, setValue] = useState(defaultValue || questionNumber === QUESTION17 ? quiz[questionNumber.split('_')[1]]?.filter(p => !allOptions.includes(p)) : '')

  const toggleAnswer = useCallback((e) => {
    dispatch(updateQuiz({ [`${name.split('_')[1]}`]: option }))
  }, [name])

  const toggleCheckbox = useCallback((e) => {

    if (isChecked) {
      setValue('')
      dispatch(updateQuiz({ question18: null, question17: quiz[questionNumber.split('_')[1]]?.filter(p => allOptions.includes(p)) }))
    }
    if (valueType !== 'input') {
      const question = questionNumber.split('_')[1]
      const currentCheckboxIsChecked = e.target.checked
      let responses

      if (currentCheckboxIsChecked)
        responses = [...quiz[question], e.target.name]
      else {
        switch (question) {
          case 'question14':
            dispatch(updateQuiz({ question15: quiz[question].length > 0 && !quiz[question].includes('Aucun') ? quiz.question15 : null }))
            break;

          default:
            break;
        }
        responses = quiz[question].filter(response => response !== e.target.name)
      }

      dispatch(updateQuiz({ [question]: responses }))
    }
    setIsChecked(!isChecked)
  }, [isChecked, quiz, questionNumber, allOptions])

  const handleChange = useCallback((e) => {
    const { value } = e.target
    const question = questionNumber.split('_')[1]
    let responses

    if (value.length)
      responses = [...quiz[question], value]
    else responses = quiz[question].filter(response => allOptions.includes(response))

    setValue(value)
    setTimeout(() => {
      dispatch(updateQuiz({ [question]: responses }))
    }, 1500)
  }, [questionNumber, allOptions])

  if (type === 'checkbox') {
    return (
      <label
        htmlFor={option.name}
        className={`flex w-full space-x-2 items-center text-sm text-gray-700 font-light mt-4 pl-4 cursor-pointer hover:text-general-teal ${valueType !== 'text' ? '-mt-0.5' : ''}`}
        onClick={valueType !== 'text' && isChecked == false ? toggleCheckbox : null}>
        <input
          type={type}
          checked={questionNumber === QUESTION17 && !allOptions.includes(option.value) ? !!quiz[questionNumber.split('_')[1]]?.filter(p => !allOptions.includes(p)).length : isChecked}
          onChange={toggleCheckbox}
          name={option.value}
          id={option.name}
          className="checkbox checkbox-sm checkbox-accent peer"
          {...props}
        />
        {valueType === 'text' ?
          <span className="peer-checked:text-general-teal">{option.value}</span> :
          <span className='w-full'>
            <Input placeholder='Autre' value={value} onChange={handleChange} required={isChecked} focus={isChecked} invalidMessage='Veuillez entrer une valeur.' />
          </span>
        }
      </label>
    )
  }


  return (
    <label
      onClick={toggleAnswer}
      htmlFor={idEl + '-' + name}
      className={`flex w-full space-x-2 items-center text-sm text-gray-700 font-light mt-4 pl-4 cursor-pointer hover:text-general-teal`}>
      <input
        type={type}
        name={name}

        id={idEl + '-' + name}
        className="radio radio-accent peer"
        {...props}
      />
      <span className="peer-checked:text-general-teal">{option}</span>
    </label>

  )
}

export default memo(Checkbox)